<template>
  <div class="education">
    <h2>Educational Qualifications</h2>
    <p class="highlight-text">Please provide details of your educational background.</p>
    <!-- form -->
    <b-form>
    <!-- Qualification 1 -->
    <b-form-group
      label="Qualification"
    >
      <b-form-input
        :value="recruit.qualifications.qualification"
        @input="handleInput('qualification', $event, true, true)"
        :class="{
            'is-valid': !$v.recruit.qualifications.qualification.$error && recruit.qualifications.qualification,
            'is-invalid': $v.recruit.qualifications.qualification.$error
          }"
      ></b-form-input>
    </b-form-group>
    <!-- Completion Date -->
    <b-form-group
      label="Completion Date"
    >
      <b-form-input
        type="date"
        :value="recruit.qualifications.qualificationWhen"
        @input="handleInput('qualificationWhen', $event, true, true)"
        :class="{
            'is-valid': !$v.recruit.qualifications.qualificationWhen.$error && recruit.qualifications.qualificationWhen,
            'is-invalid': $v.recruit.qualifications.qualificationWhen.$error
          }"
      ></b-form-input>
    </b-form-group>
    <!-- School/University -->
    <b-form-group
      label="Name of School/University"
    >
      <b-form-input
        :value="recruit.qualifications.qualificationWhere"
        @input="handleInput('qualificationWhere', $event, true, true)"
        :class="{
            'is-valid': !$v.recruit.qualifications.qualificationWhere.$error && recruit.qualifications.qualificationWhere,
            'is-invalid': $v.recruit.qualifications.qualificationWhere.$error
          }"
      ></b-form-input>
    </b-form-group>
    <!-- Qualification 2 -->
    <b-form-group
      label="2nd Qualification"
    >
      <b-form-input
        :value="recruit.qualifications.qualification2"
        @input="handleInput('qualification2', $event, true)"
      ></b-form-input>
    </b-form-group>
    <!-- Completion Date 2 -->
    <b-form-group
      label="Completion Date"
    >
      <b-form-input
        type="date"
        :value="recruit.qualifications.qualificationWhen2"
        @input="handleInput('qualificationWhen2', $event, true)"
      ></b-form-input>
    </b-form-group>
    <!-- School/University 2 -->
    <b-form-group
      label="Name of School/University"
    >
      <b-form-input
        :value="recruit.qualifications.qualificationWhere2"
        @input="handleInput('qualificationWhere2', $event, true)"
      ></b-form-input>
    </b-form-group>

      <!--Maths-->
      <b-form-group
          label="Maths Qualification Type"
          v-if="check_referer===true"
          class="qualification-dropdown"
      >
        <b-form-select
          :options="qualificationOptions"
          :class="{
            'is-valid': !$v.recruit.qualifications.qualificationMath.$error && recruit.qualifications.qualificationMath,
            'is-invalid': $v.recruit.qualifications.qualificationMath.$error
            }"
          @change="handleInput('qualificationMath', $event, true, true)"
          :value="recruit.qualifications.qualificationMath"
         >
         </b-form-select>
      </b-form-group>

       <b-form-group v-if="recruit.qualifications.qualificationMath === 'Other'" label="Please Specify Which Maths Qualification">
        <b-form-input
            :value="recruit.qualifications.otherMathQualification"
            @input="handleInput('otherMathQualification', $event, true, true)"
            :class="{
            'is-valid': !$v.recruit.qualifications.otherMathQualification.$error && recruit.qualifications.otherMathQualification,
            'is-invalid': $v.recruit.qualifications.otherMathQualification.$error
          }"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Maths Grade Achieved">
        <b-form-input
            :value="recruit.qualifications.gradeMath"
            @input="handleInput('gradeMath', $event, true, true)"
            :class="{
            'is-valid': !$v.recruit.qualifications.gradeMath.$error && recruit.qualifications.gradeMath,
            'is-invalid': $v.recruit.qualifications.gradeMath.$error
          }"
        ></b-form-input>
      </b-form-group>

      <!--English -->

      <b-form-group
          label="English Qualification Type"
          v-if="check_referer===true"
          class="qualification-dropdown"
      >
        <b-form-select
          :options="qualificationOptions"
          :class="{
            'is-valid': !$v.recruit.qualifications.qualificationEnglish.$error && recruit.qualifications.qualificationEnglish,
            'is-invalid': $v.recruit.qualifications.qualificationEnglish.$error
            }"
          @change="handleInput('qualificationEnglish', $event, true, true)"
          :value="recruit.qualifications.qualificationEnglish"
         >
         </b-form-select>
      </b-form-group>

       <b-form-group v-if="recruit.qualifications.qualificationEnglish === 'Other'" label="Please Specify Which English Qualification">
        <b-form-input
            :value="recruit.qualifications.otherEnglishQualification"
            @input="handleInput('otherEnglishQualification', $event, true, true)"
            :class="{
            'is-valid': !$v.recruit.qualifications.otherEnglishQualification.$error && recruit.qualifications.otherEnglishQualification,
            'is-invalid': $v.recruit.qualifications.otherEnglishQualification.$error
          }"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="English Grade Achieved">
        <b-form-input
            :value="recruit.qualifications.gradeEnglish"
            @input="handleInput('gradeEnglish', $event, true, true)"
            :class="{
            'is-valid': !$v.recruit.qualifications.gradeEnglish.$error && recruit.qualifications.gradeEnglish,
            'is-invalid': $v.recruit.qualifications.gradeEnglish.$error
          }"
        ></b-form-input>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
// import BtnMain from '../../components/BtnMain'
import { required } from 'vuelidate/lib/validators'
import requiredIf from "vuelidate/lib/validators/requiredIf";
export default {
  components: {
    // BtnMain
  },
  data () {
    return {
      referer: '',
      check_referer: false,
      qualificationOptions: [
        {value: "", text: "Please select the qualification type", disabled: true}, 
        {value: "GCSE", text: "GCSE"}, 
        {value: "O Level", text: "O Level"}, 
        {value:"Other", text: "Other"}]
    }
  },
  computed: {
    ...mapState({recruit: state => state.authStore.recruit}),
    // ...mapGetters(['getRecruit', 'getSectionOpen'])
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen',
      getTravelCentresIreland: 'authStore/getTravelCentresIreland',
    })
  },
  mounted () {
    //this.referer = window.siteVar.referer
    this.check_referer = true;
    var thecentres = this.recruit.centres;
    for (const c of thecentres) {
      if (this.getTravelCentresIreland.includes(c)) {
        this.check_referer = false;
        break;
      }
    }
    this.$v.$touch()
  },
  updated () {
    // Pass validation status to vuex
    const validationData = {
      section: 'education',
      status: !this.$v.recruit.$invalid
    }
    this.updateApplicationCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateRecruitAction: 'authStore/updateRecruitAction',
      sectionOpenAction: 'authStore/sectionOpenAction',
      updateBelfastSelectedAction: 'authStore/updateBelfastSelectedAction',
      updateApplicationCompleteAction: 'authStore/updateApplicationCompleteAction'
    }),
    handleInput (input, e, nested, required) {
      // handle nested input
      const nestedItem = {
        category: 'qualifications',
        input
      }
      this.updateForm(nestedItem, e, nested)
      // If field is required run veulidate validation - to apply classes to input not to prevent user from saving
      if (required) {
        this.$v.recruit.qualifications[input].$touch()
      }
    },
    updateForm
  },
  validations: {
    recruit: {
      qualifications: {
        qualification: {
        required: required
      },
      qualificationWhen: {
        required: required
      },
      qualificationWhere: {
        required: required
      },
      qualificationMath: {
        required: requiredIf(function(){
          return this.check_referer
        })
      },
      otherMathQualification: {
        required: requiredIf(function(){
          return this.check_referer && this.recruit.qualifications.qualificationMath === "Other"
        })
      },
      gradeMath: {
        required: requiredIf(function(){
          return this.check_referer
        })
      },
      qualificationEnglish: {
        required: requiredIf(function(){
          return this.check_referer
        })
        },
      gradeEnglish: {
        required: requiredIf(function(){
          return this.check_referer
        })
      },
      otherEnglishQualification: {
        required: requiredIf(function(){
          return this.check_referer && this.recruit.qualifications.qualificationEnglish === "Other"
        })
      },
      }
    }
  }
}
</script>

<style scoped>
.qualification-dropdown, .qualification-dropdown> * {
  background-color: #fff;
  /* position: absolute; */
  width: 100% !important;
  /* top: 40px !important; */
  max-height: 200px;
  z-index: 10;
  overflow: auto;
}
</style>